package com.hyperether.goodjob.navigation

import androidx.compose.animation.AnimatedContentTransitionScope
import androidx.compose.animation.EnterTransition
import androidx.compose.animation.ExitTransition
import androidx.compose.animation.core.tween
import androidx.navigation.NavBackStackEntry
import com.hyperether.goodjob.getPlatformChecker

object NavTransitions {

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getEnterTransition(): EnterTransition {
        return if (getPlatformChecker().isMobile()) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            EnterTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getExitTransition(): ExitTransition {
        return if (getPlatformChecker().isMobile()) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            ExitTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getPopEnterTransition(): EnterTransition {
        return if (getPlatformChecker().isMobile()) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        } else {
            EnterTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getPopExitTransition(): ExitTransition {
        return if (getPlatformChecker().isMobile()) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        } else {
            ExitTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getDashboardEnterTransition(): EnterTransition {
        return if (getPlatformChecker().isMobile()) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        } else {
            EnterTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getDashboardExitTransition(): ExitTransition {
        return if (getPlatformChecker().isMobile()) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            ExitTransition.None
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getUsersEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getUsersExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            target?.startsWith("jobs") == true ||
            target?.startsWith("job_details") == true ||
            target?.startsWith("scheduler") == true ||
            target?.startsWith("contacts") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_employee") == true ||
            target?.startsWith("employee_details") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getUserDetailsEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getUserDetailsExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            target?.startsWith("jobs") == true ||
            target?.startsWith("job_details") == true ||
            target?.startsWith("scheduler") == true ||
            target?.startsWith("contacts") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_employee") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getJobsEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getJobsExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            target?.startsWith("scheduler") == true ||
            target?.startsWith("contacts") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_job") == true ||
            target?.startsWith("job_details") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getJobDetailsEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getJobDetailsExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            target?.startsWith("scheduler") == true ||
            target?.startsWith("contacts") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_job") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getSchedulerEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getSchedulerExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            target?.startsWith("contacts") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getContactsEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getContactsExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_contact") == true ||
            target?.startsWith("contact_details") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getContactDetailsEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true ||
            initial?.startsWith("contacts") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getContactDetailsExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true ||
            initial?.startsWith("contacts") == true ||
            target?.startsWith("map") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("add_new_contact") == true ||
            target?.startsWith("add_new_site") == true ||
            target?.startsWith("add_new_job") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getPlacesEnterTransition(initial: String?): EnterTransition {
        if (!getPlatformChecker().isMobile()) return EnterTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true ||
            initial?.startsWith("contacts") == true ||
            initial?.startsWith("contact_details") == true
        ) {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideIntoContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }

    fun AnimatedContentTransitionScope<NavBackStackEntry>.getPlacesExitTransition(
        initial: String?,
        target: String?
    ): ExitTransition {
        if (!getPlatformChecker().isMobile()) return ExitTransition.None

        return if (initial?.startsWith("dashboard") == true ||
            initial?.startsWith("employees") == true ||
            initial?.startsWith("employee_details") == true ||
            initial?.startsWith("jobs") == true ||
            initial?.startsWith("job_details") == true ||
            initial?.startsWith("scheduler") == true ||
            initial?.startsWith("contacts") == true ||
            initial?.startsWith("contact_details") == true ||
            target?.startsWith("profile_settings") == true ||
            target?.startsWith("pricing") == true ||
            target?.startsWith("register") == true
        ) {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.Start,
                animationSpec = tween()
            )
        } else {
            slideOutOfContainer(
                towards = AnimatedContentTransitionScope.SlideDirection.End,
                animationSpec = tween()
            )
        }
    }
}